<template>
  <div class="listbox"
      :style="getStyle()"
    >
    <listbox-item
      v-for="(item, index) in list"
      :key="index"
      :item="item"
      :list-map="listMap"
      :action="action"
      @item-action="actionEvent(item, $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'Listbox',
  props: {
    list: {
      type: Array,
      default: () => []
    }, // 列表数据,
    listMap: {
      type: Function,
      default: () => null
    },
    action: {
      type: Object,
      default: () => null
    },
    height: Function // 设置的高度
  },
  methods: {
    actionEvent(item, event) {
      this.$emit('item-action', {
        action: event.type === 'action' ? this.action : { name: 'item' },
        item
      })
    },
    // 设置内容高度
    getStyle() {
      let height = document.documentElement.clientHeight
      height = this.height(height)
      // 滚动条模式
      return height ? {
        height: height + 'px',
        overflow: 'scroll'
      } : null
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
